import { formatDate } from "@/lib/utils"
import { BannerData, PostData } from "@/types/types"

export const getPostFields = (post: PostData) => {
  const attributes = post?.attributes  // ✅ guard ở đây

  const postImage =
    attributes?.image?.data?.attributes?.url ||
    attributes?.cover?.data?.attributes?.url ||
    null
  const postTitle = attributes?.title ?? ""
  const description = attributes?.description ?? ""
  const postSlug = attributes?.slug ?? ""
  const publishedAt = attributes?.publishedAt ?? null
  const formattedPublishedAt = publishedAt
    ? formatDate(publishedAt).formattedDate.replace(/\//g, "-")
    : ""
  return { postImage, postTitle, description, postSlug, publishedAt, formattedPublishedAt }
}

export const pickBannerImage = (banner: BannerData | undefined, isMobile: boolean) => {
  if (!banner) return undefined
  return isMobile
    ? banner.attributes?.mobileBanner?.data?.attributes?.url || banner.attributes?.banner?.data?.attributes?.url
    : banner.attributes?.banner?.data?.attributes?.url || banner.attributes?.mobileBanner?.data?.attributes?.url
}

const pickImageFormatFromAttributes = (
  imageAttributes: { url: string; formats?: any } | null | undefined,
  format?: "thumbnail" | "small" | "medium" | "large" | "original"
): string | undefined => {
  if (!imageAttributes) return undefined

  if (!format || format === "original" || !imageAttributes.formats) {
    return imageAttributes.url
  }

  const formats = imageAttributes.formats

  if (formats[format]?.url) {
    return formats[format].url
  }

  const formatOrder: Array<"large" | "medium" | "small" | "thumbnail"> = ["large", "medium", "small", "thumbnail"]
  const currentIndex = formatOrder.indexOf(format)

  if (currentIndex >= 0) {
    for (let i = 0; i < currentIndex; i++) {
      const largerFormat = formatOrder[i]
      if (formats[largerFormat]?.url) {
        return formats[largerFormat].url
      }
    }
  }

  return imageAttributes.url
}

export const pickBannerImageFormat = (
  banner: BannerData | undefined,
  isMobile: boolean,
  format?: "thumbnail" | "small" | "medium" | "large" | "original"
): string | undefined => {
  if (!banner) return undefined

  const bannerImage = isMobile
    ? banner.attributes?.mobileBanner?.data?.attributes || banner.attributes?.banner?.data?.attributes
    : banner.attributes?.banner?.data?.attributes || banner.attributes?.mobileBanner?.data?.attributes

  return pickImageFormatFromAttributes(bannerImage, format)
}

export const pickPostImageFormat = (
  post: PostData | undefined,
  format?: "thumbnail" | "small" | "medium" | "large" | "original"
): string | undefined => {
  if (!post) return undefined  // ✅ guard ở đây

  const postImage =
    post.attributes?.image?.data?.attributes ||   // ✅ optional chaining
    post.attributes?.cover?.data?.attributes

  return pickImageFormatFromAttributes(postImage, format)
}